import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';

type Props = {
  chatInstanceId: number;
  onSuccess?: () => void;
};

export const useRenameChatInstanceMutation = ({ chatInstanceId, onSuccess }: Props) => {

  const dispatch = useContext(ChatStateDispatchContext);

  const apiClient = useChatApiClient();

  const mutation = useMutation({
    mutationKey: ['chat:patch:rename'],

    mutationFn: (name: string) => {
      return apiClient.chatInstances.renameChatInstance({
        chatInstanceId,
        name,
      });
    },

    onSuccess: res => {
      dispatch({
        type: 'chat-instance-renamed',
        payload: {
          chatInstance: res.chatInstance,
        },
      });
      onSuccess?.();
    },
  });

  return mutation;
};